module.exports = __webpack_public_path__ + "img/DhlNl.cdfa043d.png";